import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=768a142e&scoped=true&"
import script from "./Costs.vue?vue&type=script&lang=js&"
export * from "./Costs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a142e",
  null
  
)

export default component.exports